import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Injectable,
  InjectionToken,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WorksheetService } from '@fgb/core';
import { BehaviorSubject, delay, Observable } from 'rxjs';

import { DynamicScript, LoadScripts } from 'src/app/shared/utilities/load-scripts.function';

@Injectable({ providedIn: 'root' })
export class AmgPlayerService {
  static behaviourSubject: BehaviorSubject<any>;

  constructor() {}

  addVideo(wId: string, uiconf_Id: number): Observable<any> {
    if (AmgPlayerService.behaviourSubject == null) {
      AmgPlayerService.behaviourSubject = new BehaviorSubject<any>('initializing');

      LoadScripts([
        {
          src: `https://mp.streamamg.com/p/${wId}/sp/${wId}00/embedIframeJs/uiconf_id/${uiconf_Id}/partner_id/${wId}`,
        },
      ] as DynamicScript[]).then(() => {
        AmgPlayerService.behaviourSubject.next('loaded');
      });
    }

    return AmgPlayerService.behaviourSubject.asObservable();
  }
}

const AMGPLAYER_CONFIG = new InjectionToken<any>('amgPlayerConfig');

@Injectable({ providedIn: 'root' })
@Component({
  selector: 'fgb-amg-player',
  templateUrl: './fgb-amg-player.component.html',
  styleUrls: ['./fgb-amg-player.component.scss'],
  providers: [
    {
      provide: AMGPLAYER_CONFIG,
      useValue: {
        wId: '3001363',
        uiconf_Id: 30032537,
      },
    },
  ],
})
export class FgbAmgPlayerComponent implements OnInit {
  private wId: string;
  private uiconf_Id: number;
  @Input() streamKey: string;
  @Input() thumbnailUrl: string;
  @Output() onStateChange = new EventEmitter();
  @ViewChild('thumbnail', { static: true }) thumbnail: any;
  player: any;
  isPlaying: boolean = false;
  private config = inject(AMGPLAYER_CONFIG);
  private destroyRef = inject(DestroyRef);

  constructor(private amgPlayerService: AmgPlayerService, private worksheetService: WorksheetService) {
    this.wId = this.config.wId;
    this.uiconf_Id = this.config.uiconf_Id;
  }

  ngOnInit() {
    this.amgPlayerService
      .addVideo(this.wId, this.uiconf_Id)
      .pipe(delay(300), takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (status) => {
          if (status == 'loaded') {
            try {
              (window as any)['kWidget'].embed({
                targetId: `kaltura_player_${this.streamKey}`,
                wid: `_${this.wId}`,
                uiconf_id: this.uiconf_Id,
                iframeEmbed: false,
                flashvars: {
                  largePlayBtn: { plugin: false },
                },
                entry_id: this.streamKey,
                readyCallback: (playerId: string) => {
                  try {
                    var kdp = document.getElementById(playerId) as any;
                    kdp.kBind('firstPlay.fp', () => {
                      console.log('firstPlay');
                      this.worksheetService.logViewStreamStart(this.streamKey);
                    });

                    kdp.kBind('playerUpdatePlayhead', (timespan: number) => {
                      if (Math.floor(timespan) % 20.5 == 19) {
                        if (timespan % 20.5 > 19.72) {
                          console.log('playerUpdatePlayhead');
                          this.worksheetService.logStreamWatching(this.streamKey);
                        }
                      }
                    });
                    this.player = kdp;
                  } catch (err) {
                    console.error('Error in readyCallback:', err);
                    this.onStateChange.emit({ error: err });
                  }
                },
              });
            } catch (err) {
              console.error('Error embedding player:', err);
              this.onStateChange.emit({ error: err });
            }
          }
        },
        error: (err) => {
          console.error('Error loading video:', err);
          this.onStateChange.emit({ error: err });
        },
      });
  }

  get style() {
    return {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100%',
      border: 'none',
    };
  }

  play(): void {
    if (this.player) {
      this.player.sendNotification('doPlay');
      this.isPlaying = true;
    }
  }
}
